import { render } from "./SorryPage.vue?vue&type=template&id=74a6b084&scoped=true"
import script from "./SorryPage.vue?vue&type=script&lang=js"
export * from "./SorryPage.vue?vue&type=script&lang=js"

import "./SorryPage.vue?vue&type=style&index=0&id=74a6b084&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a6b084"]])

export default __exports__